/*
 *                     NOTICE
 *            COPYRIGHT 2021 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

/**
 * Context to provide functionality to different levels of the boolean logic tree
 */

import * as React from "react";
export const AbBooleanLogicTreeContext = /*#__PURE__*/React.createContext(undefined);
//# sourceMappingURL=AbBooleanLogicTreeContext.js.map
